export default "__VITE_ASSET__BcYF3AgJ__"